import './fund-areas.component.scss'

class FundCard {
  constructor(el, classes) {
    this.elements = {
      wrap: el
    }
    this.classes = classes

    this.init()
  }

  defineElements() {
    this.elements.main = this.elements.wrap.querySelector(`.${this.classes.main}`)
    this.elements.hidden = this.elements.wrap.querySelector(`.${this.classes.hidden}`)
  }

  setHeightVar() {
    const mainHeight = this.elements.main.clientHeight
    const hiddenHeight = this.elements.hidden.clientHeight

    const resHeight = `${((mainHeight > hiddenHeight) ? mainHeight : hiddenHeight) + 100}px`

    this.elements.wrap.style.setProperty('--card-height', resHeight)
  }

  defineEvents() {
    window.addEventListener('DOMContentLoaded', this.setHeightVar.bind(this))
    window.addEventListener('resize', this.setHeightVar.bind(this))
  }

  init() {
    this.defineElements()

    this.setHeightVar()
    this.defineEvents()
  }
}

const fundSectionEl = document.querySelector('.fund-areas')
if (fundSectionEl) {
  const fundCardsList = fundSectionEl.querySelectorAll('.fund-card')
  fundCardsList.forEach(card => {
    new FundCard(card, {
      main: 'fund-card__main-content',
      hidden: 'fund-card__hidden-content'
    })
  })
}